import { guestCheckoutEn } from "./guest-checkout";

export const en = {
  common: {
    addToCart: "Add to Cart",
    buyNow: "Buy Now",
    viewDetails: "View Details",
    quickView: "Quick View",
    loading: "Loading...",
    error: "An error occurred",
    search: "Search products...",
    searchPlaceholder: "What are you looking for?",
    noResults: "No results found",
    tryAgain: "Try again",
    yes: "Yes",
    no: "No",
    cancel: "Cancel",
    delivery: "Delivery",
    paymentFee: "Payment Fee",
    free: "FREE",
  },
  product: {
    inStock: "In Stock",
    outOfStock: "Out of Stock",
    lowStock: "Only {count} left",
    specifications: "Specifications",
    description: "Description",
    reviews: "Reviews",
    relatedProducts: "Related Products",
    relatedProductsDescription: "Discover products curated just for you",
    newArrival: "New",
    featured: "Featured",
    sale: "Sale",
    brand: "Brand",
    sku: "SKU",
    category: "Category",
    tags: "Tags",
    quantity: "Quantity",
    save: "Save",
    available: "available",
    outOfStockVariant: "Out of Stock",
    selectVariant: "Select a Variant",
    selectVariantMessage: "Please select all variant options before adding to cart",
    selectVariantBuyMessage: "Please select all variant options before buying",
    addedToCart: "Added to Cart!",
    productAddedToCart: "{name} added to your cart",
    redirectingToCart: "Redirecting to Cart",
    adding: "Adding...",
    chooseVariant: "Choose variant",
    addToCartFailed: "Could not add to cart",
    addToCartFailedMessage: "{name} could not be added. Please try again.",
  },
  // Product listings (brand pages, /products, search results)
  listing: {
    filters: "Filters",
    clearAll: "Clear All",
    priceRange: "Price Range",
    sortRelevance: "Most Relevant",
    sortPriceAsc: "Price: Low to High",
    sortPriceDesc: "Price: High to Low",
    sortNameAsc: "Name: A-Z",
    sortNameDesc: "Name: Z-A",
    sortNewest: "Newest First",
    sortPopular: "Most Popular",
    noProducts: "No Products Found",
    noSearchResults: 'No products found for "{query}". Try a different search term.',
    noFilterResults: "No products match your selected filters. Try adjusting or clearing filters.",
    noBrandProducts: "We couldn't find any products for this brand.",
    clearSearch: "Clear Search",
    clearAllFilters: "Clear All Filters",
    searchResultsFor: 'Search results for "{query}"',
    // The /products?keyword= page's <title>.
    searchResultsTitle: "Search results for “{query}”",
    products: "Products",
    filtering: "Filtering products...",
    filterCategories: "Categories",
    filterBrands: "Brands",
  },
  pagination: {
    // {items} is the caller's English item label ("products"); the other
    // languages word the sentence with their own noun and leave it out.
    showing: "Showing {from} - {to} of {total} {items}",
    previous: "Previous",
    next: "Next",
    pageOf: "of {total}",
  },
  cart: {
    title: "Shopping Cart",
    empty: "Your cart is empty",
    emptyDescription:
      "Looks like you haven't added anything to your cart yet. Start shopping to fill it up!",
    startShopping: "Start Shopping",
    subtotal: "Subtotal",
    subtotalItems: "Subtotal ({count} items)",
    total: "Total",
    checkout: "Proceed to Checkout",
    continueShopping: "Continue Shopping",
    remove: "Remove",
    quantity: "Quantity",
    loadingCart: "Loading cart...",
    clearCart: "Clear Cart",
    clearConfirm: "Clear all items?",
    syncing: "Updating cart with latest prices...",
    itemsUpdated: "Some items were updated:",
    itemRemoved: "{name} was removed from your cart",
    orderSummary: "Order Summary",
    haveCoupon: "Have a coupon?",
    enterCode: "Enter code",
    apply: "Apply",
    invalidCoupon: "Invalid coupon code",
    couponValidationFailed: "Failed to validate coupon",
    removeCoupon: "Remove coupon",
    discount: "Discount",
    coupon: "Coupon",
    tax: "Tax (VAT)",
    shippingAtCheckout: "Shipping calculated at checkout",
    vatBadge: "VAT {percent}%",
    decreaseQuantity: "Decrease quantity",
    increaseQuantity: "Increase quantity",
    removeItem: "Remove item",
    removeItemTitle: "Remove Item",
    removeItemConfirm:
      'Are you sure you want to remove "{name}" from your cart? This action cannot be undone.',
    saveAmount: "Save {amount}",
  },
  checkout: {
    loading: "Loading checkout...",
    title: "Checkout",
    subtitle: "Complete your order in just a few steps",
    backToCart: "Back to Cart",
    processingOrder: "Processing Your Order",
    processingWait: "Please wait while we confirm your order...",
    fixErrors: "Please fix the errors below",
    noShippingOptions: "No shipping options available for this address",
    shippingFetchFailed: "Failed to fetch shipping options. Please try again.",
    shippingMethodUnavailable: "Selected shipping method is not available",
    fillCustomerInfo: "Please fill in customer information",
    completeCustomerForm: "Please complete the customer information form",
    firstNameRequired: "First name is required",
    phoneRequired: "Phone number is required",
    addressRequired: "Address is required",
    cityRequired: "Town/City is required",
    fillField: "Please fill in: {field}",
    fillFields:
      "Please fill in {count} required fields (scroll down to see highlighted fields)",
    fieldFirstName: "First Name",
    fieldLastName: "Last Name",
    fieldPhone: "Phone",
    fieldAddress: "Address",
    fieldAddressLine2: "Address Line 2",
    fieldCity: "City",
    fieldPostcode: "Postcode",
    fieldCountry: "Country",
    selectDeliveryMethod:
      "Please select a delivery method before confirming your order.",
    selectPaymentMethod:
      "Please select a payment method before confirming your order.",
    paymentMethodUnavailable:
      "Selected payment method is not available. Please select a different payment method.",
    transactionIdRequired: "Transaction ID is required for payment verification.",
    screenshotRequired: "Payment screenshot is required for verification.",
    bankSlipRequired: "Bank transfer slip is required.",
    orderMissingId: "Order created but missing ID. Please check your order history.",
    bkashInitFailed: "Failed to initiate bKash payment",
    gatewayConnectFailed: "Could not connect to payment gateway",
    bkashPaymentFailed:
      "bKash payment failed: {error}. Your order was placed but is not paid yet — please contact the store to pay for it.",
    shurjopayPaymentFailed:
      "Your order was placed, but the shurjoPay payment could not be started: {error}. The order is not paid yet — please contact the store.",
    orderCreationFailed: "Order creation failed",
    orderProcessingError:
      "An error occurred while processing your order. Please try again.",
    selectDeliveryLocation: "Select Delivery Location",
    selectLocationHint:
      "Please select your Country, Division, and City above to see available shipping options and delivery charges.",
    // CustomerInformationForm
    customerInfo: "Customer Information",
    clear: "Clear",
    useSavedAddress: "Use Saved Address",
    addNewAddress: "Add New Address",
    defaultBadge: "Default",
    noteLabel: "Note:",
    fieldName: "Name",
    enterFullName: "Enter your full name",
    addressLabel: "Address Label",
    labelHome: "Home",
    labelWork: "Work",
    labelOffice: "Office",
    labelOther: "Other",
    selectLabel: "Select Label",
    addressLine1Label: "Address Line 1",
    addressLine1Placeholder: "House 123, Road 45",
    addressLine2Placeholder: "Banani",
    selectCountry: "Select Country",
    divisionState: "Division/State",
    selectDivision: "Select Division",
    cityDistrict: "City/District",
    selectCity: "Select City",
    optional: "Optional",
    formatLabel: "Format:",
    deliveryInstructionsOptional: "Delivery Instructions (Optional)",
    deliveryInstructionsPlaceholder: "Please call before delivery...",
    // DeliveryMethodSelection
    selectDeliveryMethodTitle: "Select Delivery Method",
    calculatingDelivery: "Calculating delivery charge...",
    selectDeliveryToContinue: "Please select a delivery method to continue",
    homeDelivery: "Home Delivery",
    homeDeliveryDesc: "Get your order delivered to your doorstep",
    homeDeliveryEta: "3-5 business days",
    storePickup: "Store Pickup",
    storePickupDesc: "Collect your order from our store",
    storePickupEta: "Ready in 2-4 hours",
    unitMinute: "minute",
    unitMinutes: "minutes",
    unitDay: "day",
    unitDays: "days",
    unitHour: "hour",
    unitHours: "hours",
    unitDayShort: "d",
    unitHourShort: "h",
    // OrderOverview
    orderOverview: "Order Overview",
    discountSavings: "Discount Savings",
    estDelivery: "Est. delivery: {time}",
    payableRounded: "Payable (Rounded)",
    processing: "Processing...",
    confirmOrder: "Confirm Order",
    // CheckoutCouponInput
    couponCode: "Coupon Code",
    enterCouponCode: "Enter coupon code",
    // PaymentMethodSelection
    selectPaymentMethodTitle: "Select Payment Method",
    sendPaymentTo: "Send payment to:",
    accountType: "({name} - Personal/Merchant)",
    transactionId: "Transaction ID",
    enterTrxId: "Enter TrxID",
    screenshot: "Screenshot",
    uploadScreenshot: "Upload screenshot",
    uploadImageFile: "Please upload an image file",
    fileTooLarge: "File size must be less than 10MB",
    imageProcessFailed: "Failed to process image",
    uploadImageOrPdf: "Please upload an image or PDF file",
    bankSlip: "Bank Slip",
    uploadBankSlip: "Upload bank slip",
    bankLabel: "Bank:",
    nameLabel: "Name:",
    accountLabel: "A/C:",
    branchLabel: "Branch:",
    notesLabel: "Notes",
    paymentReference: "Payment reference",
    cashOnDelivery: "Cash on Delivery",
    onlinePayment: "Online Payment",
    offlinePayment: "Offline Payment",
  },
  orderSuccess: {
    title: "Order Confirmed!",
    subtitle:
      "Thank you for your order. We've received it and will process it shortly.",
    orderDetails: "Order Details",
    orderIdLabel: "Order ID:",
    orderStatus: "Order Status",
    paymentStatus: "Payment Status",
    paymentMethod: "Payment Method",
    totalItems: "Total Items",
    estimatedDelivery: "Estimated Delivery",
    confirmationEmailSent: "A confirmation email has been sent to",
    orderPlacedOn: "Order placed on {date}",
    deliveryInfo: "Delivery Information",
    phoneLabel: "Phone:",
    emailLabel: "Email:",
    orderItems: "Order Items ({count})",
    variantLabel: "Variant: {variant}",
    qty: "Qty: {quantity}",
    perUnitDiscount: "-{amount}/unit",
    vatIncluded: "VAT included: {amount}",
    whatNext: "What happens next?",
    confirmEmailNote: "You'll receive an order confirmation email at",
    trackingNote: "We'll send you tracking information once your order ships",
    expectedDelivery: "Expected delivery: {date}",
    processedSoon: "Your order will be processed and shipped soon",
    codNote: "Payment will be collected upon delivery",
    downloadPdf: "Download PDF",
    backToHome: "Back to Home",
    pdfFailed: "Failed to generate PDF. Please try again.",
  },
  payment: {
    title: "Complete Payment",
    subtitle: "You're one step away from completing your order",
    backToCheckout: "Back to Checkout",
    totalAmount: "Total Amount",
    demoNotice: "This is a demo payment page. No actual payment will be processed.",
    cardNumber: "Card Number",
    expiryDate: "Expiry Date",
    cvv: "CVV",
    processing: "Processing Payment...",
    payAmount: "Pay {amount}",
    sslNotice: "🔒 Payments are secured with 256-bit SSL encryption",
    failed: "Payment failed. Please try again.",
  },
  // The page a shopper returns to from an online payment gateway (shurjoPay).
  gatewayReturn: {
    processingTitle: "Confirming your payment",
    processing: "Checking with shurjoPay. This takes a few seconds.",
    paidTitle: "Payment successful",
    paid: "Your payment was received and your order is confirmed.",
    redirecting: "Taking you to your order...",
    pendingTitle: "Payment not finished yet",
    pending: "shurjoPay has not confirmed this payment yet. If you completed it, check again in a minute.",
    mismatchTitle: "Payment needs a check",
    mismatch: "shurjoPay reported a payment that does not match your order total. Your order is not marked paid yet; the store has the details and will contact you.",
    cancelledTitle: "Payment cancelled",
    cancelled: "You cancelled the payment. Your order is saved but not paid.",
    failedTitle: "Payment failed",
    failed: "shurjoPay did not accept the payment. Your order is saved but not paid.",
    errorTitle: "Could not confirm the payment",
    error: "We could not confirm this payment right now. If money left your account, check again in a minute or contact the store.",
    sessionMissing: "This payment was started in another browser, or the session has expired. Check your orders to see its status.",
    checkAgain: "Check again",
    viewOrders: "View my orders",
    backToShop: "Back to shop",
  },
  header: {
    home: "Home",
    shop: "Shop",
    categories: "Categories",
    brands: "Brands",
    account: "My Account",
    login: "Login",
    logout: "Logout",
    wishlist: "Wishlist",
    cart: "Cart",
    blog: "Blog",
  },
  auth: {
    // Shared fields
    emailLabel: "Email Address",
    emailPlaceholder: "your@email.com",
    passwordLabel: "Password",
    confirmPasswordLabel: "Confirm Password",
    passwordHint: "Must be at least 8 characters",
    signIn: "Sign In",
    signInLink: "Sign in",
    signingIn: "Signing in...",
    genericError: "An error occurred. Please try again.",
    genericErrorLater: "An error occurred. Please try again later.",
    invalidEmail: "Invalid email address",
    invalidPassword: "Invalid password",
    // Login
    welcomeBack: "Welcome Back",
    signInSubtitle: "Sign in to your account to continue",
    rememberMe: "Remember me",
    forgotPasswordLink: "Forgot password?",
    sessionExpired: "Your session has expired. Please log in again.",
    loginSuccess: "Login successful! Redirecting...",
    loginFailed: "Login failed. Please try again.",
    saveLoginFailed: "Failed to save login data. Please try again.",
    invalidPasswordFormat: "Invalid password format",
    noAccount: "Don't have an account?",
    signUpNow: "Sign up now",
    // Signup
    createAccount: "Create Account",
    signupSubtitle: "Join us and start your shopping journey",
    nameLabel: "Full Name",
    namePlaceholder: "John Doe",
    phoneLabel: "Phone Number",
    phonePlaceholder: "05x xxx xxxx or 01xxxxxxxxx",
    agreeToTermsPrefix: "I agree to the",
    agreeToTermsSuffix: "",
    termsAndConditions: "Terms and Conditions",
    and: "and",
    privacyPolicy: "Privacy Policy",
    errNameMin: "Name must be at least 2 characters",
    errEmailRequired: "Email is required",
    errEmailInvalid: "Email is invalid",
    errPhoneRequired: "Phone number is required",
    errPhoneInvalid: "Enter a valid phone number",
    errPasswordRequired: "Password is required",
    errPasswordMin: "Password must be at least 8 characters",
    errConfirmPasswordRequired: "Please confirm your password",
    errPasswordsMismatch: "Passwords do not match",
    errTermsRequired: "You must agree to the terms and conditions",
    fixValidationErrors: "Please fix the validation errors",
    otpSendFailed: "Failed to send verification code.",
    otpSendFailedRetry: "Failed to send verification code. Please try again.",
    signupFailed: "Signup failed. Please try again.",
    phoneVerified: "Phone Verified!",
    creatingAccount: "Creating your account...",
    accountCreated: "Account created successfully! Redirecting...",
    sendingCode: "Sending verification code...",
    alreadyHaveAccount: "Already have an account?",
    // Mobile OTP auth (mobile-only tenants)
    mobileSignInSubtitle:
      "Sign in with your mobile number — we'll text you a code.",
    mobileNumberLabel: "Mobile Number",
    sendVerificationCode: "Send Verification Code",
    signingYouIn: "Signing you in…",
    getStarted: "Get Started",
    mobileSignupSubtitle:
      "Shop faster with just your name and mobile number. No email or password required — we'll verify you with a quick SMS code.",
    creatingYourAccount: "Creating your account…",
    createOne: "Create one",
    verifyYourPhone: "Verify Your Phone",
    otpSentTo: "We sent a 6-digit code to",
    verifyCode: "Verify Code",
    verifying: "Verifying...",
    verifiedCreating: "Verified! Creating account...",
    resendIn: "Resend code in {time}",
    resendCode: "Resend Code",
    changePhoneNumber: "Change phone number",
    errOtpEnter6: "Please enter the 6-digit code",
    errOtpResendFailed: "Failed to resend OTP.",
    errOtpInvalid: "Invalid OTP code. Please try again.",
    errVerificationFailed: "Verification failed. Please try again.",
    // Forgot password
    forgotTitle: "Forgot Password",
    forgotSubtitle:
      "Enter your email address and we'll send you a link to reset your password.",
    checkYourEmail: "Check Your Email",
    resetLinkSentTo: "We've sent a password reset link to",
    checkSpam: "Didn't receive the email? Check your spam folder or try again.",
    tryAnotherEmail: "Try Another Email",
    sending: "Sending...",
    sendResetLink: "Send Reset Link",
    rememberPassword: "Remember your password?",
    // Reset password
    resetTitle: "Reset Password",
    resetSubtitle: "Enter your new password below.",
    newPasswordLabel: "New Password",
    newPasswordPlaceholder: "Enter new password",
    confirmNewPasswordPlaceholder: "Confirm new password",
    invalidResetLink: "Invalid Reset Link",
    invalidResetLinkDesc: "This password reset link is invalid or has expired.",
    requestNewLinkHint: "Please request a new password reset link.",
    requestNewLink: "Request New Link",
    resetSuccessTitle: "Password Reset Successfully",
    resetSuccessDesc: "Your password has been reset. Redirecting to login...",
    goToLogin: "Go to Login",
    resettingPassword: "Resetting Password...",
    // Email verification
    verifyingEmail: "Verifying your email...",
    emailVerifiedTitle: "Email Verified",
    emailVerifiedDesc: "Your email address has been verified successfully.",
    continueToCheckout: "Continue to Checkout",
    continueToLogin: "Continue to Login",
    verifyFailedTitle: "Verification Failed",
    verifyFailedDesc: "This verification link is invalid or has expired.",
    verifyFailedHint:
      "Log in to your account and resend a new verification email from checkout.",
    // Checkout verification gate
    verificationRequiredTitle: "Verify Your Account",
    verificationRequiredDesc:
      "Please verify your email address before placing an order. We'll send a verification link to:",
    resendVerification: "Resend Verification Email",
    verificationSent: "Verification email sent!",
    checkInbox: "Check your inbox and click the link to verify your email.",
    iVerifiedRefresh: "I've verified — refresh",
    resendCooldown:
      "A verification email was sent recently. Please wait a minute before trying again.",
  },
  account: {
    // Dashboard
    hello: "Hello,",
    notLoggedIn: "Not Logged In",
    notLoggedInMessage: "Please log in to access your account dashboard.",
    backToDashboard: "Back to Dashboard",
    ordersCard: "Orders",
    ordersCardDesc: "View and track your orders",
    profileCard: "Profile",
    profileCardDesc: "View your profile information",
    changePassword: "Change Password",
    changePasswordDesc: "Update your password",
    // Complete-account (credentials) card
    completeAccountTitle: "Complete your account",
    completeAccountMessage:
      "You signed up with just a mobile number. Add an email and a password so you can log in on other devices.",
    addEmail: "Add email",
    emailAdded: "Email added.",
    addEmailFailed: "Failed to add email",
    setPasswordLabel: "Set a password",
    setPassword: "Set password",
    passwordSet: "Password set.",
    setPasswordFailed: "Failed to set password",
    saving: "Saving…",
    // Profile
    profileInformation: "Profile Information",
    editProfile: "Edit Profile",
    name: "Name",
    email: "Email",
    mobile: "Mobile",
    mobileNumber: "Mobile Number",
    notSet: "Not set",
    userId: "User ID",
    updateProfile: "Update Profile",
    updating: "Updating...",
    profileUpdated: "Profile updated successfully! Redirecting...",
    profileUpdateFailed: "Profile update failed. Please try again.",
    invalidInput: "Invalid or malicious input detected: ",
    loadingCountries: "Loading countries...",
    loadingDivisions: "Loading divisions...",
    loadingCities: "Loading cities...",
    selectCountryFirst: "Select country first",
    noDivisions: "No divisions available",
    noCities: "No cities available",
    selectCityOptional: "Select city/district (optional)",
    selectDivisionHint: "Select the division or state",
    selectedValue: "Selected: {name}",
    cityOptionalHint: "Optional: Select a specific city or district",
    // Security / password
    currentPassword: "Current Password",
    currentPasswordPlaceholder: "Enter your current password",
    confirmNewPasswordLabel: "Confirm New Password",
    currentPasswordRequired: "Current password is required",
    newPasswordRequired: "New password is required",
    newPasswordMin: "New password must be at least 8 characters",
    newPasswordSame: "New password must be different from current password",
    invalidCurrentPassword: "Invalid current password format",
    invalidNewPassword: "Invalid new password",
    securityTipTitle: "Security tip:",
    securityTipBody:
      "Use a strong password with at least 8 characters, including uppercase, lowercase, numbers, and special characters.",
    passwordUpdated: "Password updated successfully! Returning to profile...",
    passwordUpdateFailed: "Password update failed. Please try again.",
    // Orders
    myOrders: "My Orders",
    noOrdersYet: "No orders yet",
    noOrdersMessage: "You haven't placed any orders yet.",
    showingOrders: "Showing {from} - {to} of {total} orders",
    orderNumberTitle: "Order #{number}",
    orderNumber: "Order Number",
    date: "Date",
    items: "Items",
    payment: "Payment",
    loadingOrders: "Loading orders...",
    fetchOrdersFailed: "Failed to fetch orders",
    loadOrdersFailed: "Failed to load orders. Please try again.",
    businessIdRequired: "Business ID is required to fetch orders.",
    pageOf: "Page {current} of {last}",
    previous: "Previous",
    next: "Next",
    backToOrders: "Back to Orders",
    orderNotFound: "Order not found",
    fetchOrderDetailsFailed: "Failed to fetch order details",
    loadOrderDetailsFailed: "Failed to load order details. Please try again.",
    // Order / payment statuses (backend values)
    statusPending: "Pending",
    statusProcessing: "Processing",
    statusConfirmed: "Confirmed",
    statusCompleted: "Completed",
    statusCancelled: "Cancelled",
    statusShipped: "Shipped",
    statusDelivered: "Delivered",
    statusPaid: "Paid",
    statusFailed: "Failed",
    statusRefunded: "Refunded",
    statusOnHold: "On hold",
    // Addresses
    myAddresses: "My Addresses",
    addressCountOne: "1 address",
    addressCount: "{count} addresses",
    noAddresses: "No addresses saved",
    noAddressesMessage: "Add a new address to save it for future orders",
    editAddress: "Edit Address",
    updateAddress: "Update Address",
    addAddress: "Add Address",
    adding: "Adding...",
    deleting: "Deleting...",
    edit: "Edit",
    delete: "Delete",
    confirm: "Confirm",
    deleteAddressTitle: "Delete Address",
    deleteAddressConfirm:
      "Are you sure you want to delete this address? This action cannot be undone.",
    fetchAddressesFailed: "Failed to fetch addresses",
    loadAddressesFailed: "Failed to load addresses. Please try again.",
    deleteAddressFailed: "Failed to delete address. Please try again.",
    updateAddressFailed: "Failed to update address",
    addAddressFailed: "Failed to add address",
    addressLabelPlaceholder: "e.g., Home, Office, etc.",
    streetAddressPlaceholder: "Street address",
    addressLine2Placeholder: "Apartment, suite, etc. (optional)",
    county: "County",
    countryUnitedKingdom: "United Kingdom",
    countryUnitedStates: "United States",
    countryCanada: "Canada",
    countryAustralia: "Australia",
    countryIreland: "Ireland",
    countrySaudiArabia: "Saudi Arabia",
    countryBangladesh: "Bangladesh",
    // Wishlist
    myWishlist: "My Wish List",
    itemCountOne: "1 item",
    itemCount: "{count} items",
    wishlistEmpty: "Your wish list is empty",
    wishlistEmptyMessage:
      "Start adding your favorite products to save them for later",
    gridView: "Grid view",
    tilesView: "Tiles view",
    clearWishlist: "Clear Wishlist",
    clearing: "Clearing...",
    clearWishlistConfirm:
      "Are you sure you want to clear your entire wishlist? This action cannot be undone.",
    clearWishlistFailed: "Failed to clear wishlist. Please try again.",
    removeFromWishlist: "Remove from wishlist",
    removing: "Removing...",
    removeWishlistFailed:
      "Failed to remove item from wishlist. Please try again.",
    addedOn: "Added {date}",
    viewProduct: "View Product",
    loadingWishlist: "Loading wishlist...",
    fetchWishlistFailed: "Failed to fetch wishlist",
    loadWishlistFailed: "Failed to load wishlist. Please try again.",
    // Common
    noAccessToken: "No access token found. Please log in again.",
  },
  footer: {
    aboutUs: "About Us",
    contactUs: "Contact Us",
    privacyPolicy: "Privacy Policy",
    termsOfService: "Terms of Service",
    returnPolicy: "Return Policy",
    shippingInfo: "Shipping Information",
    followUs: "Follow Us",
    newsletter: "Newsletter",
    subscribeNewsletter: "Subscribe to our newsletter",
    enterEmail: "Enter your email",
    subscribe: "Subscribe",
  },
  guestCheckout: guestCheckoutEn,
};

/** Shape every locale dictionary must match — a missing key is a compile error. */
export type TranslationDict = typeof en;
